import * as types from '../../../actions/actiontypes';

import {HttpStatusCodes, clientRequestDocumentsTabIDs, documentTypes} from '../../../util/uiconstants';

import Utility from '../../../util/utilityfunctions';
import {getFileNameAndExtension} from '@ey/utils';
import initialState from '../../initialstate';

export default function clientRequestDocumentsReducer(state = initialState.clientRequestDocuments, action) {
	switch (action.type) {
		case types.GET_ASSOCIATED_CLIENT_REQUEST_DOCUMENTS: {
			const result = buildAssociatedDocumentsList(action.response);
			return result;
		}
		case types.ASSOCIATE_EXISTING_DOCUMENT: {
			if (HttpStatusCodes.Created === action.responseObj.status && action.documentBelongsToCurrentClientRequest) {
				let newState = _.cloneDeep(state);

				let uploadedDocuments = newState.find((x) => x.id === clientRequestDocumentsTabIDs.taskDocuments);
				let associatedDocument = null;
				if (action.documentName) {
					// came from upload document flow
					const [documentName, fileExt] = getFileNameAndExtension(action.documentName);
					associatedDocument = {
						id: action.response.documentId,
						documentID: action.response.documentId,
						documentName: documentName || 'Document',
						fileExt: fileExt || 'docx',
						clientRequestDocumentID: action.response.id,
						lastModifiedFullName: action.userName,
						modifiedDate: action.responseObj.data.createDate,
						clientSignOffJSON: null,
						confidentialityTypeId: action.document ? action.document.confidentialityTypeId : null,
						documentTypeId: documentTypes.CRASH
					};

					let newDocuments1 = uploadedDocuments.documents.slice();
					// remove if file exist in the collection
					newDocuments1 = newDocuments1.filter((x) => x.id !== action.response.documentId);
					newDocuments1.splice(0, 0, associatedDocument);

					uploadedDocuments.documents = newDocuments1;
				} else {
					associatedDocument = {
						id: action.document.id,
						clientRequestDocumentID: action.response.id,
						clientSignOffJSON: null,
						documentName: action.document.documentName,
						fileExt: action.document.fileExt,
						documentTypeId: action.document.documentTypeId,
						confidentialityTypeId: action.document.confidentialityTypeId
					};

					uploadedDocuments.documents.push(associatedDocument);

					if (associatedDocument.documentTypeId === documentTypes.CANVASFORMEVIDENCE) {
						let externalUploadedDocuments = newState.find(
							(x) => x.id === clientRequestDocumentsTabIDs.externalDocuments
						);
						externalUploadedDocuments.documents.push(associatedDocument);
					}
				}

				return newState;
			}
			return state;
		}
		case types.DELETE_ASSOCIATED_DOCUMENT: {
			if (HttpStatusCodes.NoContent === action.responseObj.status) {
				let newState = _.cloneDeep(state);

				let uploadedDocuments = newState.find((x) => x.id === clientRequestDocumentsTabIDs.taskDocuments);
				uploadedDocuments.documents = uploadedDocuments.documents.filter((doc) => doc.id !== action.documentId);

				let externalUploadedDocuments = newState.find((x) => x.id === clientRequestDocumentsTabIDs.externalDocuments);
				externalUploadedDocuments.documents = externalUploadedDocuments.documents.filter(
					(doc) => doc.id !== action.documentId
				);

				return newState;
			}
			return state;
		}
		case types.MARK_AS_DELETED_DOCUMENT: {
			if (HttpStatusCodes.Ok === action.responseObj.status) {
				let newStateDR = _.cloneDeep(state);
				// delete event
				if (action.IsMarkedAsDeleted) {
					let deleteDocument;
					let taskDocuments;
					let deletedDocuments;
					// Search the document that the user select to delete in External tab
					let externalDocuments = newStateDR.find((x) => x.id === clientRequestDocumentsTabIDs.externalDocuments);
					deleteDocument = externalDocuments.documents.filter((doc) => doc.id === action.documentId);
					if (deleteDocument.length === 0) {
						// if the document is not in External tab, search in Documents tab
						taskDocuments = newStateDR.find((x) => x.id === clientRequestDocumentsTabIDs.taskDocuments);
						deleteDocument = taskDocuments.documents.filter((doc) => doc.id === action.documentId);
						if (deleteDocument.length > 0) {
							// if the document is in Documents tab, delete from Documents tab
							taskDocuments.documents = taskDocuments.documents.filter((doc) => doc.id !== action.documentId);
						}
					} else {
						// if the document is in External tab, delete from External tab
						externalDocuments.documents = externalDocuments.documents.filter((doc) => doc.id !== action.documentId);
					}
					if (deleteDocument.length > 0) {
						deletedDocuments = newStateDR.find((x) => x.id === clientRequestDocumentsTabIDs.deletedDocuments);
						// With the document that was found and it is deleting, set the Mark
						deleteDocument[0].isMarkedAsDeleted = action.IsMarkedAsDeleted;
						// and add it in the Deleted tab
						deletedDocuments.documents.push(deleteDocument[0]);
						// then sort the Deleted tab by documentName
						deletedDocuments.documents.sort(function(a, b) {
							return a.documentName.localeCompare(b.documentName);
						});
					}
				}
				// restore event
				else {
					// Search the document that the user select to restore in Deleted tab
					let deletedDocuments = newStateDR.find((x) => x.id === clientRequestDocumentsTabIDs.deletedDocuments);
					let restoreDocument = deletedDocuments.documents.filter((doc) => doc.id === action.documentId);
					// and delete the document to restore from Deleted tab
					deletedDocuments.documents = deletedDocuments.documents.filter((doc) => doc.id !== action.documentId);
					if (restoreDocument.length == 1) {
						// With the document that was found and it is restoring, set the Mark
						restoreDocument[0].isMarkedAsDeleted = action.IsMarkedAsDeleted;
						// if the origin of the document was the External tab
						if (
							restoreDocument[0].documentTypeId === documentTypes.CLIENTFILES ||
							restoreDocument[0].documentTypeId === documentTypes.AUTOMATIONHUBCLIENTOUTPUT
						) {
							// add the document to restore in External tab and then sort by documentName
							let externalDocuments = newStateDR.find((x) => x.id === clientRequestDocumentsTabIDs.externalDocuments);
							externalDocuments.documents.push(restoreDocument[0]);
							externalDocuments.documents.sort(function(a, b) {
								return a.documentName.localeCompare(b.documentName);
							});
						} else {
							// if the origin of the document was the Documents tab
							// add the document to restore in Documents tab and then sort by documentName
							let taskDocuments = newStateDR.find((x) => x.id === clientRequestDocumentsTabIDs.taskDocuments);
							taskDocuments.documents.push(restoreDocument[0]);
							taskDocuments.documents.sort(function(a, b) {
								return a.documentName.localeCompare(b.documentName);
							});
						}
					}
				}
				return newStateDR;
			}
		}
		case types.UPDATE_ANALYTIC_DOCUMENT_NAME: {
			let newState = _.cloneDeep(state);
			let filteredDocuments = newState.find((x) => x.id === action.clientRequestDocumentTabId);
			if (filteredDocuments) {
				filteredDocuments.documents?.map((m) => {
					if (m.id === action.documentId) {
						m.documentName = action.documentName;
						m.isRenameAnalyticDocumentSyncError = false;
					}
				});
			}
			return newState;
		}
		default:
			return state;
	}
}

function buildAssociatedDocumentsList(response) {
	const data = [...response.data];

	const documentNameSorter = (element) => {
		return element.documentName.toLowerCase();
	};

	const fileExtensionSorter = (element) => {
		return element.fileExt.toLowerCase();
	};

	const documentTypeIdSorter = (element) => {
		return element.documentTypeId;
	};

	const documentListSorter = (array) => {
		return _.orderBy(array, [documentNameSorter, fileExtensionSorter], ['asc', 'asc']);
	};

	const documentPriorPeriodSorter = (array) => {
		return _.orderBy(array, [documentTypeIdSorter, documentNameSorter, fileExtensionSorter], ['desc', 'asc', 'asc']);
	};

	let clientApprovals;
	if (data && data.length > 0) {
		for (let i = 0; i < data.length; i++) {
			let document = data[i];

			for (let i = 0; i < document.clientApprovals.length; i++) {
				console.log(document.clientApprovals?.clientSignoffJson);
				if (typeof document.clientApprovals[i].clientSignoffJson === 'string') {
					let objectFromJson;
					try {
						/*turn lastName and firstName into LastName and FirstName*/
						let cleanedUp = document.clientApprovals[i].clientSignoffJson
							.replaceAll(/"firstName"/g, '"FirstName"')
							.replaceAll(/"lastName"/g, '"LastName"')
							.replaceAll(/"SignOffDate"/g, '"CreateDate"')
							.replaceAll(/"createDate"/g, '"CreateDate"')
							.replaceAll(/"userRole"/g, '"UserRole"');
						objectFromJson = JSON.parse(cleanedUp);
					} catch (error) {
						objectFromJson = undefined;
					}
					document.clientApprovals[i] = {
						clientSignOffJson: objectFromJson,
						id: document.clientApprovals[i].id
					};
				}
			}
			clientApprovals = Utility.normalize(document.clientApprovals, clientApprovals);
			document.clientApprovals =
				document.clientApprovals && document.clientApprovals.map((clientApproval) => clientApproval.id);
			data[response.data[i].id] = document;
		}
	}

	const taskDocumentsTypesExcluded = [
		documentTypes.CLIENTFILES,
		documentTypes.AUTOMATIONHUBCLIENTOUTPUT,
		documentTypes.PRIOR_PERIOD_CLIENT_FILES,
		documentTypes.PRIOR_PERIOD_AUTOMATION_HUB_OUTPUT,
		documentTypes.PRIOR_PERIOD_EY_SENT_TO_CLIENT_FILES
	];

	return [
		{
			id: clientRequestDocumentsTabIDs.externalDocuments,
			documents: documentListSorter(
				data.filter(
					(x) =>
						!x.isMarkedAsDeleted &&
						(x.documentTypeId === documentTypes.CLIENTFILES ||
							x.documentTypeId === documentTypes.AUTOMATIONHUBCLIENTOUTPUT ||
							x.documentTypeId === documentTypes.CANVASFORMEVIDENCE)
				)
			),
			clientApprovals
		},
		{
			id: clientRequestDocumentsTabIDs.taskDocuments,
			documents: documentListSorter(
				data.filter((x) => !x.isMarkedAsDeleted && !taskDocumentsTypesExcluded.includes(x.documentTypeId))
			)
		},
		{
			id: clientRequestDocumentsTabIDs.deletedDocuments,
			documents: documentListSorter(data.filter((x) => x.isMarkedAsDeleted))
		},
		{
			id: clientRequestDocumentsTabIDs.priorPeriodDocuments,
			documents: documentPriorPeriodSorter(
				data.filter(
					(x) =>
						!x.isMarkedAsDeleted &&
						(x.documentTypeId === documentTypes.PRIOR_PERIOD_CLIENT_FILES ||
							x.documentTypeId === documentTypes.PRIOR_PERIOD_AUTOMATION_HUB_OUTPUT ||
							x.documentTypeId === documentTypes.PRIOR_PERIOD_EY_SENT_TO_CLIENT_FILES)
				)
			)
		}
	];
}
